import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-body',
  templateUrl: './page-body.component.html',
  styleUrls: ['./page-body.component.scss']
})
export class PageBodyComponent implements OnInit {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";

  trustedDescription: SafeHtml = null;

  constructor(
    private sanitiser: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.trustedDescription = this.sanitiser.bypassSecurityTrustHtml(this.data.page_body.description)
  }

}
